/* eslint-disable no-shadow */
const state = {
	comments: {
		scope: 'comments',
		limit: 20,
	},
};

const getters = {

};

const mutations = {

};

const actions = {
	'comments/list': async function ({ dispatch, commit, state, getters }, reset = false) {
		commit('SET_DATA_LOADING', { value: true, type: state.comments.scope });

		let offset;
		if (reset) offset = 0; else offset = getters[`data/${state.comments.scope}`].results.length;
		const comments = await this.$sdk.admin().comments.list(offset, state.comments.limit);

		const result = {
			ok: false,
			state: 'complete',
		};

		if (comments.ok) {
			result.ok = true;

			dispatch('addData', { data: comments.data, type: state.comments.scope, reset });

			if (offset < comments.data.total) result.state = 'loaded';
		}

		commit('SET_DATA_LOADING', { value: false, type: state.comments.scope });

		return result;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
